<template>
  <div>
    <div class="mt-2">
      <DynamicValueSwitch
        v-if="!moduleGraphStore.isAuthScreen"
        v-model="validationProperties.isRequired"
        :is-dynamic="validationProperties.isRequiredDynamic"
        label="Is field required"
        class="mb-2"
        @update-dynamic-switch="updateValidationProperty('isRequiredDynamic', $event)"
      />
    </div>
    <DynamicValueSwitch
      v-if="validationProperties.isRequired || validationProperties.isRequiredDynamic"
      v-model="validationProperties.isRequiredMessage"
      :is-dynamic="validationProperties.isRequiredMessageDynamic"
      label="Required error message"
      class="mt-1 mb-2"
      custom-switch-classes="is-flex-direction-column-reverse"
      dynamic-switch-classes="ml-auto"
      @update-dynamic-switch="toggleDynamicSwitch"
    >
      <BaseInput
        v-model="validationProperties.isRequiredMessage"
        label="Required error message"
        expanded
      />
    </DynamicValueSwitch>
  </div>
</template>

<script >
import { set } from '@vue/composition-api';
import { useValidationProperties } from '@/modules/builder/components/form-builder/properties/field-properties/validation-properties/validationProperties';
import BaseInput from '@/modules/core/components/generics/BaseInput.vue';
// Stores
import { useModuleGraphStore } from '@/modules/builder/store/moduleGraphStore';
import DynamicValueSwitch from '@/modules/core/components/DynamicValueSwitch.vue';
const __sfc_main = {};
__sfc_main.props = {
  selectedFieldType: {
    type: String,
    default: 'field'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    validationProperties
  } = useValidationProperties(props.selectedFieldType);
  const moduleGraphStore = useModuleGraphStore();
  const toggleDynamicSwitch = isDynamic => {
    set(validationProperties.value, 'isRequiredMessage', '');
    set(validationProperties.value, 'isRequiredMessageDynamic', isDynamic);
  };
  const updateValidationProperty = (key, value) => {
    if (key in validationProperties.value) {
      validationProperties.value[key] = value;
    } else {
      set(validationProperties.value, key, value);
    }
  };
  return {
    validationProperties,
    moduleGraphStore,
    toggleDynamicSwitch,
    updateValidationProperty
  };
};
__sfc_main.components = Object.assign({
  DynamicValueSwitch,
  BaseInput
}, __sfc_main.components);
export default __sfc_main;
</script>
